import AssignmentIcon from '@mui/icons-material/Assignment';
import TuneIcon from '@mui/icons-material/Tune';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from '@mui/material';
import { useState } from 'react';

type Props = {
  showInactiveUsers: boolean;
  setShowInactiveUsers: (show: boolean) => void;
  setActivityLogModalOpen: (open: boolean) => void;
};

export default function AccountContactsFilterMenu({
  showInactiveUsers,
  setShowInactiveUsers,
  setActivityLogModalOpen,
}: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleShowInactiveUsers = () => {
    setShowInactiveUsers(!showInactiveUsers);
    setAnchorEl(null);
  };

  const handleShowActivityLog = () => {
    setActivityLogModalOpen(true);
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton onClick={handleClick}>
        <TuneIcon />
      </IconButton>

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {showInactiveUsers ? (
          <MenuItem onClick={handleShowInactiveUsers}>
            <ListItemIcon sx={{ mr: 0 }}>
              <VisibilityOffIcon sx={{ color: 'text.secondary' }} />
            </ListItemIcon>
            <ListItemText primary="Hide deactivated users" />
          </MenuItem>
        ) : null}

        {!showInactiveUsers ? (
          <MenuItem onClick={handleShowInactiveUsers}>
            <ListItemIcon sx={{ mr: 0 }}>
              <VisibilityIcon sx={{ color: 'text.secondary' }} />
            </ListItemIcon>
            <ListItemText primary="Show deactivated users" />
          </MenuItem>
        ) : null}

        <MenuItem onClick={handleShowActivityLog}>
          <ListItemIcon sx={{ mr: 0 }}>
            <AssignmentIcon sx={{ color: 'text.secondary' }} />
          </ListItemIcon>
          <ListItemText primary="Activity log" />
        </MenuItem>
      </Menu>
    </div>
  );
}
